import styled from "styled-components";

export const ActivationPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #f5f5f5;
  /* border: 1px solid red; */
  overflow: hidden;
  overflow-y: auto;
`;
export const ActivationPageTopBar = styled.div`
  display: flex;
  align-items: center;
  .bar_title {
    display: flex;
    flex-grow: 1;
  }
`;
